const links = document.querySelectorAll('a[href*="#"]');

 
for (const link of links) {
  link.addEventListener("click", clickHandler);
}

function clickHandler(e) {
  e.preventDefault();
  const href = this.getAttribute("href");
  const offsetTop = document.querySelector(href).getBoundingClientRect().top + window.scrollY - 120;
 
  scroll({
    top: offsetTop,
    behavior: "smooth"
  });
}